export default "/images/state-cap.jpg";